import { motion } from "framer-motion";
import { useLang } from "@/lib/LanguageContext";

const fade = {
    hidden: { opacity: 0, y: 30 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.9, delay: i * 0.12, ease: [0.19, 1, 0.22, 1] },
    }),
};

export default function HowItWorks() {
    const { t } = useLang();
    const steps = t("ritual.steps") || [];
    return (
        <section
            id="ritual"
            className="py-24 md:py-40 bg-[#2D2824] text-[#F9F6F0] relative overflow-hidden"
            data-testid="ritual-section"
        >
            <div className="container-x">
                <motion.div
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-80px" }}
                    variants={fade}
                    className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-28"
                >
                    <div>
                        <div className="chapter-num mb-4 text-[#B48F57]">
                            {t("ritual.chapter")}
                        </div>
                        <h2 className="font-serif text-5xl md:text-7xl tracking-[-0.02em] leading-[0.98] max-w-[16ch]">
                            {t("ritual.title_1")}
                            <br />
                            <em className="italic text-[#B48F57]">
                                {t("ritual.title_2_em")}
                            </em>
                        </h2>
                    </div>
                    <p className="max-w-[40ch] text-[15px] md:text-[17px] text-[#D9D1C7] leading-relaxed font-light">
                        {t("ritual.body")}
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-0 relative">
                    <div className="hidden md:block absolute top-4 left-[12%] right-[12%] h-px bg-[#5C564D]" />
                    {steps.map((s, i) => {
                        const n = String(i + 1).padStart(2, "0");
                        return (
                            <motion.div
                                key={n}
                                custom={i}
                                initial="hidden"
                                whileInView="show"
                                viewport={{ once: true, margin: "-80px" }}
                                variants={fade}
                                className="relative pt-10 pb-10 md:pb-0 md:pt-0 md:pr-12 border-b border-[#5C564D] md:border-b-0 md:border-r last:border-r-0 last:border-b-0"
                                data-testid={`ritual-step-${n}`}
                            >
                                <div className="relative">
                                    <div className="hidden md:flex w-2 h-2 bg-[#B48F57] absolute -top-[3px] left-0 rotate-45" />
                                    <div className="chapter-num text-[#B48F57] pl-0 md:pl-8 mb-6 md:mb-10">
                                        {n}
                                    </div>
                                    <div className="pl-0 md:pl-8 pr-6">
                                        <h3 className="font-serif text-3xl md:text-4xl mb-4 tracking-tight">
                                            {s.title}
                                        </h3>
                                        <p className="text-[15px] md:text-[16px] text-[#D9D1C7] leading-relaxed font-light max-w-[38ch]">
                                            {s.body}
                                        </p>
                                    </div>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
